"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiTextField = void 0;
exports.MuiTextField = {
    styleOverrides: {
        root: {
            "& .MuiInputBase-input": {
                fontSize: "1rem",
                lineHeight: "24px",
            },
        },
    },
};
//# sourceMappingURL=text-field.js.map